import * as React from 'react';
import type { OptionProps } from 'react-apollo';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

import waitForGraphQL from 'js/lib/waitForGraphQL';

import { ProductTypes } from 'bundles/university-program-qualification/utils/constants';
import type { Maybe } from 'bundles/xddp/__generated__/baseContentfulTypes';
import EoiForm from 'bundles/xddp/components/landing/EoiForm';

const { DEGREE } = ProductTypes;

type InnerProps = OuterProps & {
  productId: string;
};

type OuterProps = {
  slug?: string;
  shortName?: Maybe<string>;
  partnerName?: Maybe<string>;
  prepopulateUserInfo: boolean;
};

class EoiContainer extends React.Component<InnerProps> {
  static contextTypes = {
    router: PropTypes.object,
  };

  render() {
    const { productId, slug, prepopulateUserInfo, shortName, partnerName } = this.props;

    return (
      <EoiForm
        shortName={shortName}
        degreeId={productId}
        slug={slug}
        partnerName={partnerName}
        prepopulateUserInfo={prepopulateUserInfo}
        productType={DEGREE}
      />
    );
  }
}

const getDegreeBySlug = gql`
  query DegreeHomeAppQuery($slug: String!) {
    DegreesV1Resource {
      degrees: bySlug(slug: $slug) {
        elements {
          id
        }
      }
    }
  }
`;

export default compose<InnerProps, OuterProps>(
  waitForGraphQL(getDegreeBySlug, {
    props: (props: OptionProps) => ({
      productId:
        props.data &&
        props.data.DegreesV1Resource &&
        props.data.DegreesV1Resource.degrees.elements[0] &&
        props.data.DegreesV1Resource.degrees.elements[0].id,
    }),
  })
)(EoiContainer);
